import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { IntlShape } from 'react-intl'

import { OpenModalEvent } from './modalMachine'

export const getConfirmDependantApplicationDataChangeModal = ({
  onConfirm,
  onCancel,
  intl,
}: {
  onConfirm: () => void
  onCancel?: () => void
  intl: IntlShape
}): OpenModalEvent => {
  return {
    type: 'OPEN',
    data: {
      header: intl.formatMessage({ id: 'common-application-confirm-dependent-data-clearing-header' }),
      children: (
        <BodyText>{intl.formatMessage({ id: 'common-application-confirm-dependent-data-clearing-text' })}</BodyText>
      ),
      primaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-cancel' }),
        onClick: onCancel,
        type: 'primary',
      },
      secondaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-continue-anyway' }),
        onClick: onConfirm,
      },
      mode: ModalVisualMode.Help,
    },
  }
}
